module.exports = __webpack_public_path__ + "img/17_46.5bda6d41.png";